import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300 dark:text-gray-600">404</h1>
        <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">{t('common.notFound')}</p>
        <Button className="mt-6" onClick={() => navigate('/dashboard')}>
          {t('nav.dashboard')}
        </Button>
      </div>
    </div>
  );
}
